export default {
  home: 'Accueil',
};
